const initialState = {
    defaultRules: [],
    defaultRulesForSelectionBox: [],
    applicationRuleNames: [],
    applicationRulesNamesForSelectionBox: [],
    defaultMatchingTypes: [],
    sourceColumns: [],
    targetColumns: [],
    matchingMappings: []
};


export default initialState;